export enum RequestSaveResultStatus {
  NoMatchingRow = 1,
  UpdatedSinceReadTime = 2,
  Success = 3,
  InsertFailed = 4,
  UpdateFailed = 5,
  DuplicateRow = 6,
  InvalidAction = 7,
  DuplicateChildEntity = 8
};
